import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router';

export const SearchModalComponent = ({
                                           showModal,
                                           closeModal
}) => {

    // Fonction pour fermer UNIQUEMENT si on clique sur le fond noir
    const handleBackdropClick = (e) => {
        // e.target est l'élément cliqué, e.currentTarget est l'élément qui porte l'événement (la div principale)
        if (e.target === e.currentTarget) {
            closeModal();
        }
    };

    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchTerm.trim() !== '') {
            // Redirige vers /recherche/le-texte-saisi
            navigate(`/recherche/${encodeURIComponent(searchTerm)}`);
            closeModal();
        }
    };

    return (
        <>
            <div
                onClick={handleBackdropClick}
                className={`modal fade ${showModal ? 'show d-block' : 'd-none'}`}
                tabIndex="-1"
                aria-labelledby="searchModalLabel"
                aria-hidden={!showModal}
                style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} // Ajoute un fond semi-transparent noir derrière la modale
            >
                <div className="modal-dialog modal-fullscreen-lg-down modal-dialog-centered">
                    <div className="modal-content border-0 shadow bg-white">
                        <div className="modal-header border-0 justify-content-between align-items-center p-4">
                          <span className="modal-title fs-5 fw-bold" id="searchModalLabel">
                            Rechercher dans le site
                          </span>
                            <button
                                type="button"
                                className="btn p-0 border-0"
                                onClick={closeModal}
                                aria-label="Close"
                            >
                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0Z"
                                        fill="#F9C977"></path>
                                    <path d="M15 29L29 15" stroke="white" stroke-width="2"
                                          stroke-linecap="round"></path>
                                    <path d="M15 15L29 29" stroke="white" stroke-width="2"
                                          stroke-linecap="round"></path>
                                </svg>
                            </button>
                        </div>

                        {/* Body */}
                        <div className="modal-body p-4 pt-0">
                            <form onSubmit={handleSearch}>
                                <div className="input-group mb-3">
                                    <input
                                        name="search"
                                        type="text"
                                        className="form-control form-control-lg rounded-0 border-0"
                                        placeholder="Rechercher..."
                                        id="modal-search-input"
                                        style={{background: 'white'}}
                                        // 2. On lie l'input à l'état React
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    {/* Optionnel : Un bouton pour soumettre, ou l'utilisateur peut juste appuyer sur "Entrée" */}
                                    <button type="submit" className="btn btn-primary d-none">Rechercher</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};